import { render, staticRenderFns } from "./PItemRow3.vue?vue&type=template&id=4592cfb6"
import script from "./PItemRow3.vue?vue&type=script&lang=js"
export * from "./PItemRow3.vue?vue&type=script&lang=js"
import style0 from "./PItemRow3.vue?vue&type=style&index=0&id=4592cfb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports